module.exports = __webpack_public_path__ + "media/reskin-images/icon--chat-with-alex-272ca87f.svg";